<template>
  <!-- MODAL EDIT -->
  <b-modal
    id="Live1"
    title="วิดีโอและภาพเหตุการณ์"
    size="lg"
    ok-only
    ok-title="ปิด"
  >
    <b-row>
      <!-- GATEWAY NAME -->

      <b-col cols="12">
        <center>
          <video
            id="live"
            style="width:600px; height:auto;"
            muted
            :src="video_path"
            playsinline
            autoplay
            controls
          />

          <b-img
            :src="image"
            width="600px"
          />
        </center>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import {
  BRow, BCol, BImg,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BImg,
    // MAP
  },
  data() {
    return {
      video_path: '',
      image: '',
    }
  },
  mounted() {
  },
  methods: {
    streamLive(value) {
      this.video_path = value
    },
    showImg(img) {
      this.image = img
    },
  },
}
</script>

<style lang="scss">
</style>
